import { AUTH_USER_POOL_WEB_CLIENT_ID } from '@cfra-nextgen-frontend/shared/src/config';
import { VerifyResponse } from 'features/auth/api';

function decodeJwtPayload(token: string): Record<string, string> {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
}

export function storeAmplifyTokens(tokens: VerifyResponse): void {
    const payload = decodeJwtPayload(tokens.idToken);
    const username = payload['cognito:username'];
    const prefix = `CognitoIdentityServiceProvider.${AUTH_USER_POOL_WEB_CLIENT_ID}`;

    localStorage.setItem(`${prefix}.LastAuthUser`, username);
    localStorage.setItem(`${prefix}.${username}.idToken`, tokens.idToken);
    localStorage.setItem(`${prefix}.${username}.accessToken`, tokens.accessToken);
    localStorage.setItem(`${prefix}.${username}.refreshToken`, tokens.refreshToken);
    localStorage.setItem(`${prefix}.${username}.clockDrift`, '0');
}
